module.exports = __webpack_public_path__ + "img/fxzmbak.5be706ab.png";